import { gql } from "@apollo/client";

const CREATE_EMAILS_NOTIFICATION = gql`
  mutation CreateEmailsNotification($emailsNotification: EmailsNotificationCreateInput!) {
    createEmailsNotification(emailsNotification: $emailsNotification) {
      success
      emailsNotification {
        id
      }
    }
  }
`;

const UPDATE_EMAILS_NOTIFICATION = gql`
  mutation UpdateEmailsNotification(
    $id: ID!
    $emailsNotification: EmailsNotificationUpdateInput!
  ) {
    updateEmailsNotification(
      id: $id
      emailsNotification: $emailsNotification
    ) {
      success
    }
  }
`;

const EMAILS_NOTIFICATIONS = gql`
  query EmailsNotifications(
    $params: QueryParams
    $location: ID
  ) {
    emailsNotifications(params: $params, location: $location) {
      info { 
        count
      }
      results {
        id
        to
        cc
        isDefault
        location {
          id
          name
        }
      }
    }
  }
`;

const GET_LOCATIONS = gql`
  query getLocations($params: QueryParams, $name: String) {
    locations(params: $params, name: $name) {
      info {
        count
      }
      results {
        id
        name
      }
    }
  }
`;

export {
  CREATE_EMAILS_NOTIFICATION,
  UPDATE_EMAILS_NOTIFICATION,
  EMAILS_NOTIFICATIONS,
  GET_LOCATIONS,
};
